import { PlasticsScrapReason } from "../models/plastics-scrap-reason.model";

export const plasticsScrapReasonOther: PlasticsScrapReason = {
    id: '8J37S6v7JlHieFyzqXwS',
    name: 'other',
    description: 'something that doesnt fit any other categories',
    active: true,
}